import {BODEGA} from "../Constantes";

export const adapt_pedido_cotizacion = (pedido) => {


    const obtenerProductos = (productos) => {

        let arr = []

        for (let i = 0; i < productos.length; i++) {

            let prod = productos[i]

            let obj = {
                "sat_description": prod.id,
                "sat_code": '50202206',
                "weight": prod.peso ?  Math.ceil(parseInt(prod.peso) / 1000) : 5000, //peso
                "length": prod.largo ?  prod.largo : 15, //largo
                "width": prod.ancho ?  prod.ancho : 15, //ancho
                "height": prod.alto ?  prod.alto : 25,//alto
                "price": prod.valor

            }

            for (let j = 0; j < parseInt(prod.cantidad); j++) {
                arr.push(obj)
            }

        }

        return arr

    }

    const sumarValores = (cajas) => {
        if (cajas.length === 0) return {alto: 0, ancho: 0, largo: 0,  peso: 0};

        const inicial = {
            alto: 0,
            ancho: 0,
            largo: 0,
            peso: 0,
        };

        return cajas.reduce((acc, caja) => {

            return {
                // Apilado vertical
                alto: acc.alto + caja.height,
                // Dimensiones máximas
                ancho: Math.max(acc.ancho, caja.width),
                largo: Math.max(acc.largo, caja.length),
                // Suma de peso y volumen
                peso: acc.peso + caja.weight,
            };

        }, inicial);
    }


    let productoCovertidos = obtenerProductos(pedido.productos)
    let valoresTotales = sumarValores(productoCovertidos);

    let obj = {
        "origin_postal_code": BODEGA.codigo, //Código postal de origen
        "destination_postal_code": pedido.codigoDestino, //Código postal de destino
        "weight": valoresTotales.peso, //Peso del paquete en kilogramos
        "length": valoresTotales.largo, // Largo del paquete en centímetros
        "width": valoresTotales.ancho, //Ancho del paquete en centímetros
        "height": valoresTotales.alto, //Alto del paquete en centímetros
        "shipping_days": 0, //
        "insurance": false,	//Indica si el paquete está asegurado
        "package_value": 0, //Valor del paquete (requerido si insurance=true)
        "package_type": 2, //2 === paquete
        "packages": 1, //numero de paquete
        "products": productoCovertidos
    }

    return obj

}